import React, { FC, Fragment } from "react";
import { Box, Divider } from "@mui/material";
import { XsText } from "../Text";
import { COLORS } from "constants/layout";

interface AttributesDisplayProps {
  attributes: Array<{ key: string; value: string }>;
}

const AttributesDisplay: FC<AttributesDisplayProps> = ({ attributes }) => (
  <Box
    sx={{
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      gap: "4px",
      rowGap: "4px",
      maxHeight: "38px", // 2 rows * 24px (line height)
      overflow: "hidden",
      position: "relative",
      '&:after': {
        content: '""',
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        height: '24px',
        pointerEvents: 'none',
        display: attributes.length > 0 ? 'block' : 'none',
      },
      "& .ellipsis-text": {
        lineHeight: "18px",
      }
    }}
  >
    {attributes.map((attr, i) => (
      <Fragment key={i}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            whiteSpace: "nowrap",
            minWidth: 0,
          }}
        >
          <XsText className="ellipsis-text categories" component="span">
            {attr.key}: <span>{attr.value}</span>
          </XsText>
        </Box>
      </Fragment>
    ))}
  </Box>
);

export default AttributesDisplay; 